import React from 'react';
import { AppProps } from 'next/app';
import { ContainerModule, Container } from 'inversify';
import isServer from '@/Framework/Router/Next/isServer';
import { createContainer, PageRenderingState } from '@/Framework/DI';
import { TYPES } from '@/Framework/config/DI/types';
import { loadModules } from '@/Framework/Bootstrap/loadModules';

type WithContainerProps = AppProps & {
  container: Container,
};

  export const configureApp = (
    Component: React.ComponentType<WithContainerProps>,
    modules: ContainerModule[] = [],
  ) => {
    // On Server Side we need to recreate container for each request
    // On Client Side we need to remember container in the closure.
    let clientContainer: Container | null = null;

    if (!isServer()) {
      clientContainer = createContainer(PageRenderingState.ClientSideRendering);
      loadModules(clientContainer, modules);
    }

    return (props: AppProps) => {
      if (props.pageProps?.method === 'HEAD') return null;

      const container = isServer()
        ? createContainer(PageRenderingState.ServerSideRendering)
        : clientContainer!;

      if (isServer()) {
        loadModules(container, modules);
      }

      if (!container.isBound(TYPES.Hostname)) {
        container.bind<string>(TYPES.Hostname).toConstantValue(props.pageProps?.hostname || '');
      }

      return <Component container={ container } { ...props } />;
    };
  };
